import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IGlobalMessagePublic } from '@app/core/interfaces/IGlobalMessage';


@Component({
  standalone: false,
  selector: 'messages-dialog-component',
  template: `
<style>

mat-dialog-content {
  overflow: auto;
}
.nopadding{
  padding: 0px !important;
  cursor: pointer;
}
.message-content {
  white-space: pre-line;
}

</style>
<div mat-dialog-title>
  <div class="col d-flex justify-content-end nopadding">
    <mat-icon (click)="onCloseClick()">clear</mat-icon>
  </div>
</div>
<div class="container">
  <mat-dialog-content>   
    <h2>{{data.Headline}}</h2>
    <div class="message-content">{{data.Content}}</div>
  </mat-dialog-content>
</div>




`
})


export class MessagesDialogComponent {
  public message: IGlobalMessagePublic;
  constructor(
    public dialogRef: MatDialogRef<MessagesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IGlobalMessagePublic,
  ) { }

  onCloseClick(): void {
    this.dialogRef.close();
  }

}


